import { enumOptimizedMode, enumPubScopes } from "../constants";

export class QPublishSettings {
  constructor() {
    this.fCropToChart = false;
    this.fPublishScaler = null;
    this.fPPTAspect = null;
    this.fHideMaster = false;
    this.fTransparentBackground = false;
    this.fWhiteBackground = true;
    this.fDocPrintMode = enumOptimizedMode.enumForPrint;

    this.fPubScope = "Page"; //Page, Branch, Chart
    this.fDynNav = true;
    this.fUniformScaling = false;

    this.fPNGQuality = true;
    this.fDoIndex = null;
    this.fDefaultOverride = false;
    this.fDoFunctionStatements = null;
    this.fShowOverlay = true; //Mirror of the UI Config version
    this.fShowActivity = "Off"; //Change to Off when committing.
  }

  // var enumLastDocGen = { page: 0, branch: 1, book: 2};
  SetScope(aScope) {
    if (enumPubScopes.indexOf(aScope) > -1) this.fPubScope = aScope;
  }
}
